jQuery(document).ready(function () {
    var candidateRegisterButton = jQuery('button[name="register-candidate"]');

    if (candidateRegisterButton.length > 0) {
        candidateRegisterButton.click(function () {
            gtag_report_conversion();
        });
    }
});
